module.exports = __webpack_public_path__ + "img/dd7912afda11aa5bb417e2398ae61b4d.a148aa2b.webp";